import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { Article, ArticleSearchInput } from "@/graphql/gql/graphql";
import { getAllArticles } from "@/utils/api";
import { parseInfiniteArticlesResponse } from "@/utils/recentArticles";

interface RecentArticleArgs {
  limit?: number;
  sportName?: string | null;
  cursor?: string;
  hideDeprioritizedContent?: boolean;
  filters?: ArticleSearchInput;
}

const useRecentArticles = ({
  limit = 6,
  sportName,
  hideDeprioritizedContent = false,
  filters = {},
}: RecentArticleArgs) => {
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isError,
    isFetching,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    placeholderData: keepPreviousData,
    queryKey: [
      "recent-articles",
      limit,
      sportName,
      hideDeprioritizedContent,
      filters,
    ],
    queryFn: (params) =>
      getAllArticles({
        limit,
        sportName,
        hideDeprioritizedContent,
        ...filters,
        afterCursor: params.pageParam,
      }),
    getNextPageParam: (resp) => {
      if (resp.getArticles?.pageInfo?.hasNextPage) {
        return resp.getArticles?.pageInfo?.cursor;
      }
      return undefined;
    },
    initialPageParam: "",
  });

  const articles: Article[] | undefined =
    data && parseInfiniteArticlesResponse(data);

  return {
    articles,
    fetchNextPage,
    hasNextPage,
    isError,
    isLoading,
    isFetching,
    isFetchingNextPage,
    refetch,
  };
};
export default useRecentArticles;
